module.exports = __webpack_public_path__ + "img/20m8.dee78e81.jpg";